import React from 'react';
import { FormattedMessage } from 'react-intl';

const Step = ({ title, isActive, isComplete }) => (
    <li className={`progress-step${isActive ? ' is-active' : ''} ${isComplete ? ' is-complete' : ''}`}>
        <div className="progress-marker" />
        <div className="progress-text">
            <FormattedMessage id={title} defaultMessage={title} />
        </div>
    </li>
);

export default Step;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/stepper/step.jsx
 **/